import { Controller } from "@hotwired/stimulus"

// The ⋯ on the project page's Procore row (Phelipe 2026-10-06): a pop-up with
// Reports, RFIs and Submittals as tabs. The RFIs / Submittals block inside is
// swapped whole by procore-items when something changes; its
// "procore-items:swapped" event brings back the tab that was open.
export default class extends Controller {
  static targets = ["modal", "tab", "pane"]

  connect() {
    this.tab = "report"
    this._onKey = (event) => { if (event.key === "Escape" && this.hasModalTarget && !this.modalTarget.hidden) this._escape(event) }
    document.addEventListener("keydown", this._onKey)
    this._onSwap = () => this.applyTab()
    this.element.addEventListener("procore-items:swapped", this._onSwap)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKey)
    this.element.removeEventListener("procore-items:swapped", this._onSwap)
  }

  open(event) {
    event?.preventDefault()
    this.modalTarget.hidden = false
    this.applyTab()
    // Fresh RFIs / Submittals (new items, what two-way sync sent) each time
    // it opens, without reloading the page.
    const items = this.modalTarget.querySelector("[data-controller~='procore-items']")
    const controller = items && this.application.getControllerForElementAndIdentifier(items, "procore-items")
    controller?.refreshNow?.()
  }

  close(event) {
    event?.preventDefault()
    if (this.hasModalTarget) this.modalTarget.hidden = true
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  select(event) {
    this.tab = event.currentTarget.dataset.tab
    this.applyTab()
  }

  // Shows the open tab's pane (RFIs and Submittals share the Sync line under
  // them) and puts each pane's count on its tab.
  applyTab() {
    this.tabTargets.forEach((button) => {
      const on = button.dataset.tab === this.tab
      button.dataset.on = String(on)
      button.setAttribute("aria-selected", String(on))
    })
    this.paneTargets.forEach((pane) => {
      const name = pane.dataset.pane
      pane.hidden = !(name === this.tab || (name === "items-footer" && this.tab !== "report"))
      const badge = this.element.querySelector(`[data-count-for="${name}"]`)
      if (badge && pane.dataset.count !== undefined) {
        badge.textContent = pane.dataset.count
        badge.hidden = pane.dataset.count === "0"
      }
    })
  }

  // Escape closes the Review pop-up first, then this one.
  _escape(event) {
    const review = this.modalTarget.querySelector("[data-procore-items-target='modal']:not([hidden])")
    if (review) review.hidden = true
    else this.close()
    event.preventDefault()
  }
}
